import { render } from "./PoliticaPrivacidade.vue?vue&type=template&id=488f5f50"
import script from "./PoliticaPrivacidade.vue?vue&type=script&lang=js"
export * from "./PoliticaPrivacidade.vue?vue&type=script&lang=js"

import "./PoliticaPrivacidade.vue?vue&type=style&index=0&id=488f5f50&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__